import * as React from "react";
const DropDownArrowSVGComponent = (props) => (
  <svg width={20} height={20} viewBox="0 0 24 24" fill="none" {...props}>
    <title>{"Chevron down small"}</title>
    <path d="M18 8v3.8l-6 4.6-6-4.6V8l6 4.6L18 8Z" fill="currentColor" />
  </svg>
);
export default DropDownArrowSVGComponent;